import { gql } from '@apollo/client';
export const EDIT_PROFILE_MUTATION = gql`
  mutation EditProfile($data: updateUserInput!) {
    updateUser(input: $data) {
      user {
        id
        profilePicture {
          url
        }
        username
      }
    }
  }
`;
